const MOBILE_BREAKPOINT = 768;

let headingDelegationInitialized = false;
let renderFiltersPatched = false;
let filterObserver = null;
let currentObservedWrapper = null;
let currentCloseBtn = null;

function isMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function initHeadingDelegation() {
  if (headingDelegationInitialized) return;
  headingDelegationInitialized = true;

  document.addEventListener('click', (e) => {
    const heading = e.target.closest('.facets-vertical .facets__heading');
    if (!heading) return;

    const parent = heading.closest('.facet-filters');
    if (parent) {
      parent.classList.toggle('is-open');
    }
  });
}

function disconnectFilterObserver() {
  if (filterObserver) {
    filterObserver.disconnect();
    filterObserver = null;
  }
  currentObservedWrapper = null;
  currentCloseBtn = null;
}

function connectFilterObserver() {
  const wrapper = document.querySelector('.facets-vertical__sort-filter-wrapper');
  const closeBtn = document.querySelector('.filter-close');

  if (!wrapper || !closeBtn) return false;

  disconnectFilterObserver();

  currentObservedWrapper = wrapper;
  currentCloseBtn = closeBtn;

  filterObserver = new MutationObserver(() => {
    currentCloseBtn.classList.toggle('hidden', !currentObservedWrapper.classList.contains('show'));
  });

  filterObserver.observe(wrapper, {
    attributes: true,
    attributeFilter: ['class'],
  });

  return true;
}

function ensureFilterObserver() {
  if (currentObservedWrapper && document.contains(currentObservedWrapper)) return;

  disconnectFilterObserver();
  connectFilterObserver();
}

function patchRenderFilters() {
  if (
    renderFiltersPatched ||
    typeof FacetFiltersForm === 'undefined' ||
    !FacetFiltersForm.renderFilters
  ) {
    return;
  }

  renderFiltersPatched = true;

  const originalRenderFilters = FacetFiltersForm.renderFilters;

  FacetFiltersForm.renderFilters = function (html, event) {
    originalRenderFilters.call(this, html, event);
    filterUpdate();
  };
}

function filterUpdate() {
  const title = document.querySelector('#verticalTitle');
  if (title) title.textContent = 'FILTER & SORT';

  ensureFilterObserver();

  document.querySelectorAll('.facet-filters').forEach((facet) => {
    const items = facet.querySelectorAll('.facets-layout-list .facets__item');
    if (items.length <= 6) return;

    const facetsWrap = facet.querySelector('fieldset');
    if (!facetsWrap) return;

    let showAllBtn = facetsWrap.querySelector('.facets-show-all');
    if (!showAllBtn) {
      showAllBtn = document.createElement('button');
      showAllBtn.type = 'button';
      showAllBtn.className = 'facets-show-all';
      showAllBtn.textContent = 'Show all';
      facetsWrap.appendChild(showAllBtn);
    }

    for (let i = 6; i < items.length; i++) {
      items[i].classList.add('hidden');
    }

    showAllBtn.classList.remove('hidden');
    if (!showAllBtn.dataset.bound) {
      showAllBtn.dataset.bound = 'true';
      showAllBtn.addEventListener('click', () => {
        facet
          .querySelectorAll('.facets-layout-list .facets__item')
          .forEach((item) => item.classList.remove('hidden'));
        showAllBtn.classList.add('hidden');
      });
    }
  });
}

function initFilterMenu() {
  if (!isMobile()) return;

  initHeadingDelegation();
  patchRenderFilters();
  filterUpdate();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFilterMenu);
} else {
  initFilterMenu();
}
